import axios from "axios";
import { useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import "../../workers/WorkerCategories.css"
import Swal from "sweetalert2";
import "../../doorstepServices/DoorstepServices.css"
import Cookies from "js-cookie";
import moment from "moment";
import { useParams } from "react-router-dom";

interface IHelp {
   _id: string; // Unique identifier
   is_resolved: boolean; // Whether the query is resolved
   is_deleted: boolean; // Whether the query is deleted
   customer_id: string; // Customer's unique ID
   name: string; // Name of the customer
   email: string; // Email of the customer
   message: string; // The query message
   type: "worker" | "user"; // Type of customer (worker or user)
   createdAt: string; // Timestamp of when the query was created
   updatedAt: string; // Timestamp of when the query was last updated
   __v: number; // Version key
   worker_phone?: string; // Phone number of the worker (optional)
   worker_pic?: string; // Profile picture of the worker (optional)
   user_phone?: string; // Phone number of the user (optional)
   user_pic?: string; // Profile picture of the user (optional)
}

const getHelpAndSupportDataById = async (token: string, id: string) => {

   return await axios.get(`${AppConfig.DEV_SERVER}/help-support/${id}`, {
      headers: {
         "x-access-token": token
      }

   })
};


const HelpAndSupportDetailsPage = () => {
   const { id } = useParams();
   const Token = Cookies.get('token');
   const [selectedSupport, setSelectedSupport] = useState<IHelp>();

   useEffect(() => {
      getHelpAndSupportDataById(Token as string, id as string).then((res) => {
         // console.log(res)
         if (res?.data?.status_code === 200) {
            // console.log(res?.data)
            setSelectedSupport(res?.data?.data)
         } else {
            Swal.fire({
               icon: "error",
               title: "Oops...",
               text: `${res?.data?.data?.msg}`,

            });
         }
      })
   }, [id])

   //  this below code is for Category name 

   const istDate = moment(selectedSupport?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY hh:mm A');

   return (
      <MainLayout
         showAllFilters={true}

      >
         <div className="mt-3 mb-3">
            <div className=" category-main me-2 p-md-4">

               <div className="row justify-content-evenly pt-3 pb-3">
                  <div className="col-lg-5 card d-flex flex-column p-5 gap-3">
                     <strong className="text-start">
                        Help And Support Details
                     </strong>
                     <div className="d-flex flex-column gap-3">
                        <span className="text-start"> Customer Profile :</span>
                        <div className="d-flex justify-content-center align-items-center user-pic">
                           {
                              selectedSupport?.type === "worker" ?
                                 <img
                                    src={
                                       selectedSupport?.worker_pic
                                          ? typeof selectedSupport.worker_pic === 'string'
                                             ? selectedSupport.worker_pic
                                             : URL.createObjectURL(selectedSupport.worker_pic)
                                          : undefined
                                    }
                                    alt=""
                                 /> :
                                 <img
                                    src={
                                       selectedSupport?.user_pic
                                          ? typeof selectedSupport.user_pic === 'string'
                                             ? selectedSupport.user_pic
                                             : URL.createObjectURL(selectedSupport.user_pic)
                                          : undefined
                                    }
                                    alt=""
                                 />
                           }

                        </div>
                     </div>

                     <div className="d-flex flex-column gap-2">
                        <div className="d-flex gap-3">
                           <span>Posted Date :</span>
                           <span> {istDate ?? "NA"}</span>
                        </div>
                        <div className="d-flex gap-3">
                           <span>Support Id :</span>
                           <span> {selectedSupport?._id ?? "NA"}</span>
                        </div>
                        <div className="d-flex gap-3">
                           <span>Resolve Status :</span>
                           <span> {selectedSupport?.is_resolved ? "True" : "false"}</span>
                        </div>
                        <div className="d-flex gap-3">
                           <span>Customer Name :</span>
                           <span> {selectedSupport?.name ?? "NA"}</span>
                        </div>
                        <div className="d-flex gap-3">
                           <span className="text-start">Email :</span> <span className="text-start"> {selectedSupport?.email ?? "NA"} </span>
                        </div>
                        <div className="d-flex gap-2">
                           <span>Phone No :</span>
                           <span className="text-start"> {selectedSupport?.worker_phone ?? "NA"}</span>
                        </div>
                        <div className="d-flex gap-2">
                           <span>Message :</span>
                           <span className="text-start"> {selectedSupport?.message ?? "NA"}</span>
                        </div>
                     </div>
                  </div>
               </div>


            </div>

         </div>

      </MainLayout >
   )

};



export default HelpAndSupportDetailsPage;